import {
    Autocomplete,
    Button, Checkbox,
    DialogActions,
    DialogContent, FormControlLabel,
    FormHelperText,
    Grid,
    MenuItem,
    TextField,
    Alert
} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import CommonModal from "../AdminPanel/CommonModal";
import {useCreateAudienceMutation, useUpdateAudienceMutation} from "../../core/api/audience-api";
import AudienceForm from "./AudienceForm";
import {useEffect, useState} from "react";

import {v4 as uuidv4} from 'uuid';

import {semverBothParams, semverValid, validateLte, validateSingleNumber} from "../../core/utils/Validator";
import {getDuplicatesAndUniques, isEmpty} from "../../core/utils/commonUtils";
import {prepareParametersForSave} from "../../core/utils/audienceUtils";


const NUMBER_VERSION_OPERATORS = [
    'gt', 'lt', 'ge', 'le'
];
const POSSIBLE_OPERATORS: Map = new Map(Object.entries({
    'NUMBER_RANGE': NUMBER_VERSION_OPERATORS,
    'VERSION_RANGE': NUMBER_VERSION_OPERATORS,
    'INCLUDE': 'include',
    'INCLUDE_ALL': 'includeAll',
    'INCLUDE_ANY': 'includeAny',
    'EXCLUDE': 'exclude',
    'EXCLUDE_ANY': 'excludeAny',
    'EXCLUDE_ALL': 'excludeAll',
    'OFFER_IN_PROFILE': 'offerInProfile',
    'OFFER_NOT_IN_PROFILE': 'offerNotInProfile',
    'PROFILE_OFFSET': 'profileOffset',
    'TYPE_INACTIVE': 'offerTypeInactiveRule',
    'TAG_INACTIVE': 'offerTagInactiveRule',
    'TAG_NOT_IN_PROFILE': 'offerTagNotInProfileRule',
    'TAGS_IN_PROFILE': 'offerTagsInProfileRule',
    'OFFER_INACTIVE': 'offerInactiveRule'
}));


class AudienceForSave {
    includeAll = [];
    include = [];
    excludeAll = [];
    exclude = [];
    numberRange = [];
    versionRange = [];
    offerTypeInactiveRule = [];
    offerTagInactiveRule = [];
    offerTagNotInProfileRule = [];
    offerTagsInProfileRule = [];
    offerInactiveRule = [];
    offerNotInProfile = [];
    offerInProfile = [];
    profileOffset = [];
}

const BASIC_STEP_ERRORS = [];
const AUDIENCE_STEP_ERRORS = [];
const COHORT_STEP_ERRORS = [];
const AUDIENCE_PREFIX = "Audience";
const isVersionNumericParameter = (parameter) => {
    return parameter.allowedRules.includes('NUMBER_RANGE') ||
        parameter.allowedRules.includes('VERSION_RANGE');
}
class VersionNumericParameterSet {
    constructor(allowedRules, parameterName, paramFromValue = "", paramToValue = "", fromIncl = true, toIncl = false, operator = 'gt') {
        this.paramFromValue = paramFromValue;
        this.parameterData.allowedRules = allowedRules;
        this.paramToValue = paramToValue;
        this.parameterData.name = parameterName;
        this.fromIncl = fromIncl;
        this.toIncl = toIncl;
        this.operator = operator;
    }

    parameterData = {
        allowedRules: [],
        parameterName: "",
    };
}
class ParametersSet {
    constructor(allowedRules, allowedValues, isMain, parameterName, operator, paramValue = '', offerId = '', offsetValue = '', tags = '') {
        this.parameterData.allowedRules = allowedRules;
        this.parameterData.allowedValues = allowedValues;
        this.parameterData.isMain = isMain;
        this.parameterData.name = parameterName;
        this.operator = operator;
        this.paramValue = paramValue;
        this.offerId = offerId;
        this.tags = tags;
        this.offsetValue = offsetValue;
    }

    parameterData = {
        allowedRules: [],
        allowedValues: [],
        isMain: false,
        parameterName: "",
    };
    operator = "";
    paramValue = "";
}

class AudienceError {
    constructor(audienceIndex, paramIndex, fieldValue, fieldName, errorId) {
        this.audienceIndex = audienceIndex;
        this.paramIndex = paramIndex;
        this.fieldValue = fieldValue;
        this.fieldName = fieldName;
        this.errorId = errorId;
    }
}


const prepareParametersForUpdate = (_audienceForUpdate) => {
    let audienceForUpdate = {..._audienceForUpdate}
    let parameters = []
    audienceForUpdate?.versionRange.forEach(versionItem => {
        parameters.push(new VersionNumericParameterSet(['VERSION_RANGE'], versionItem.parameter, versionItem.from ? versionItem.from : null, versionItem.to ? versionItem.to : null, versionItem.fromIncluded, versionItem.toIncluded));
    });
    audienceForUpdate.numberRange !== undefined && audienceForUpdate.numberRange.forEach(rangeItem => {
        parameters.push(new VersionNumericParameterSet(['NUMBER_RANGE'], rangeItem.parameter, rangeItem.from, rangeItem.to, rangeItem.fromIncluded, rangeItem.toIncluded));
    });

    let available_attributes = ['includeAny','excludeAny','includeAll','excludeAll'];
    available_attributes.forEach((operator) => {
        if (audienceForUpdate.hasOwnProperty(operator) && audienceForUpdate[operator] != null) {
            audienceForUpdate[operator].forEach(includeItem => {
                let rules = includeItem.parameter === 'country' ? ['INCLUDE', 'EXCLUDE'] : ['INCLUDE'];
                parameters.push(new ParametersSet(rules, [], null, includeItem.parameter, operator, includeItem.values));
            })


        }
    })
    //
    // audienceForUpdate.include.forEach(includeItem => {
    //     let rules = includeItem.parameter === 'country' ? ['INCLUDE', 'EXCLUDE'] : ['INCLUDE'];
    //     parameters.push(new ParametersSet(rules, [], null, includeItem.parameter, "include", includeItem.values));
    // });
    // audienceForUpdate.exclude.forEach(excludeItem => {
    //     let rules = excludeItem.parameter === 'country' ? ['INCLUDE', 'EXCLUDE'] : ['INCLUDE'];
    //     parameters.push(new ParametersSet(rules, [], null, excludeItem.parameter, "exclude", excludeItem.values));
    // });
    // if (audienceForUpdate.offerTypeInactiveRule) {
    //     audienceForUpdate.offerTypeInactiveRule.forEach(offerTypeInactiveRuleItem => {
    //         parameters.push(new ParametersSet(['TYPE_INACTIVE'], [], null, offerTypeInactiveRuleItem.parameter, "offerTypeInactiveRule", offerTypeInactiveRuleItem.types));
    //
    //     });
    // }
    // if (audienceForUpdate.offerInactiveRule) {
    //     audienceForUpdate.offerInactiveRule.forEach(offerInactiveRuleItem => {
    //         parameters.push(new ParametersSet(['OFFER_INACTIVE'], [], null, offerInactiveRuleItem.parameter, "offerInactiveRule", offerInactiveRuleItem.offerIds));
    //
    //     });
    // }
    // if (audienceForUpdate.offerInProfile) {
    //     audienceForUpdate.offerInProfile.forEach(offerInProfileItem => {
    //         parameters.push(new ParametersSet(['OFFER_IN_PROFILE'], [], null, offerInProfileItem.parameter, "offerInProfile", offerInProfileItem.offerId));
    //
    //     });
    // }
    // if (audienceForUpdate.offerNotInProfile) {
    //     audienceForUpdate.offerNotInProfile.forEach(offerNotInProfileItem => {
    //         parameters.push(new ParametersSet(['OFFER_NOT_IN_PROFILE'], [], null, offerNotInProfileItem.parameter, "offerNotInProfile", offerNotInProfileItem.offerId));
    //
    //     });
    // }
    // if (audienceForUpdate.offerInactiveRule) {
    //     audienceForUpdate.offerInactiveRule.forEach(item => {
    //         parameters.push(new ParametersSet(['TYPE_INACTIVE'], [], null, item.parameter, "offerInactiveRule", item.offerId));
    //
    //     });
    // }
    // if (audienceForUpdate.offerTagNotInProfileRule) {
    //     audienceForUpdate.offerTagNotInProfileRule.forEach(offerTypeInactiveRuleItem => {
    //         parameters.push(new ParametersSet(['TAG_NOT_IN_PROFILE'], [], null, offerTypeInactiveRuleItem.parameter, "offerTagNotInProfileRule", offerTypeInactiveRuleItem.tags));
    //
    //     });
    // }
    // if (audienceForUpdate.offerTagsInProfileRule) {
    //     audienceForUpdate.offerTagsInProfileRule.forEach(offerTypeInactiveRuleItem => {
    //         parameters.push(new ParametersSet(['TAGS_IN_PROFILE'], [], null, offerTypeInactiveRuleItem.parameter, "offerTagsInProfileRule", offerTypeInactiveRuleItem.tags));
    //
    //     });
    // }
    // if (audienceForUpdate.offerTypeInactiveRule) {
    //     audienceForUpdate.offerTypeInactiveRule.forEach(item => {
    //         parameters.push(new ParametersSet(['OFFER_INACTIVE'], [], null, item.parameter, "offerTypeInactiveRule", item.offerId));
    //
    //     });
    // }
    // if (audienceForUpdate.profileOffset) {
    //     audienceForUpdate.profileOffset.forEach(profileOffset => {
    //         parameters.push({
    //             parameterData: {
    //                 parameterName:profileOffset.parameter,
    //                 allowedRules:['PROFILE_OFFSET'],
    //             },
    //             isMain: null,
    //             operator: profileOffset.operator,
    //             parameter: profileOffset.parameter,
    //             offerId: profileOffset.offerId,
    //             offset: profileOffset.offset //"PT" + profileOffset.offset / 3600 +"H"
    //         });
    //
    //     });
    // }
    return parameters;
}

const prepareAudiencesForUpdate = (abTest) => {
    return abTest.audiences.map((audienceForUpdate, index) => {
        return {
            name: `Audience ${index + 1}`,
            count: index + 1,
            parameters: prepareParametersForUpdate(audienceForUpdate)
        }
    })
}

const createNewAbTest = () => {
    let newAbTest = {audiences:[]};
    newAbTest.audiences = prepareAudiencesForUpdate(newAbTest);
    return newAbTest;
}

const createDefaultPlatformParameter = () => {
    const platformParam = new ParametersSet(
        ['INCLUDE_ANY'], // allowedRules
        [], // allowedValues (пустой массив, так как значения будут добавляться динамически)
        true, // isMain
        'platform', // parameterName
        'includeAny', // operator
        [] // paramValue (пустой массив, будет заполнен позже)
    );
    return platformParam;
};


export default function CreateAudienceModal({open, handleDialogClose, parameters}) {

    const [createAudience, createAudienceResponse] = useCreateAudienceMutation()
    const [updateAudience, updateAudienceResponse] = useUpdateAudienceMutation()

    const [errorText, setErrorText] = useState(null)

    console.log('parameters')
    console.log(parameters)

    const [currentAbTest, setCurrentAbTest] = useState({
        audiences: [
            {
                name: `Audience 1`,
                count: 1,
                parameters: parameters === false ? [
                    createDefaultPlatformParameter()
                ] : parameters.filter
            }
        ]
    });
    const [audienceStepErrors, setAudienceStepErrors] = useState(AUDIENCE_STEP_ERRORS);
    const [basicStepErrors, setBasicStepErrors] = useState(BASIC_STEP_ERRORS);



    const [audienceTitle, setAudienceTitle] = useState({
        title:"",
        description:"",
        platform:""
    })

    useEffect(() => {
        console.log('parameters2')
        console.log(parameters)
        if(parameters !== false) {
            setAudienceTitle({
                title: parameters.title,
                description: parameters.description,
                platform: parameters.filter.platform
            })

            setCurrentAbTest({
                audiences: [
                    {
                        name: `Audience 1`,
                        count: 1,
                        parameters: prepareParametersForUpdate(parameters.filter)
                    }
                ]
            })

            console.log(prepareParametersForUpdate(parameters.filter))
        } else {

        }
    },[parameters])


    const handleChange = (event) => {
        let value = event.target.value;
        if (event.target.name === 'priority') {
            value = +value
            value = (value === 0 || value > 0) ? value : currentAbTest.priority
        }
        if (event.target.name === 'reassignCohort') {
            value = event.target.checked;
        }

        if (event.target.name === 'link') {
            setCurrentAbTest({
                ...currentAbTest,
                'metaData': {
                    'link': value
                },
                'groupId': event.target.name === 'abTestId' || event.target.name === 'groupId' ? value : currentAbTest.groupId
            });
        } else {
            setCurrentAbTest({
                ...currentAbTest,
                [event.target.name]: value,
                'groupId': event.target.name === 'abTestId' || event.target.name === 'groupId' ? value : currentAbTest.groupId
            });
        }


    }

    const handleManualInput = (e, paramIndex, currentAudienceIndex) => {
        let newCurrentAbTest = {...currentAbTest};
        const currentParam = getCurrentParam(newCurrentAbTest, paramIndex, currentAudienceIndex);
        currentParam.paramValue = e.target.value;
        setCurrentAbTest(newCurrentAbTest);
        _validateManualInput();
    }

    const handleAddNewParams = (audienceIndex) => {
        let audiences = [...currentAbTest.audiences];
        let currentAudience = audiences[audienceIndex]
        let newAudienceParameters = currentAudience.parameters;
        newAudienceParameters.push(new ParametersSet())
        audiences[audienceIndex].parameters = newAudienceParameters
        handleChange({
            'target': {
                'name': 'audiences',
                'value': audiences
            }
        })
    }

    const handleDeleteParams = (audienceIndex, paramIndex) => {
        let audiences = [...currentAbTest.audiences];
        let currentAudience = audiences[audienceIndex]
        let newAudienceParameters = currentAudience.parameters;
        newAudienceParameters.splice(paramIndex, 1);
        audiences[audienceIndex].parameters = newAudienceParameters
        handleChange({
            'target': {
                'name': 'audiences',
                'value': audiences
            }
        })
        _sameParametersCheck()
    }

    const handleAddNewAudience = (index) => {
        let newAudiences = [...currentAbTest.audiences];
        let absentNumbers = _findAbsentAudiences(newAudiences);
        let newAudienceCounter = absentNumbers.length > 0 ? absentNumbers[0] : index + 1

        newAudiences.push({
            'name': `${AUDIENCE_PREFIX} ${newAudienceCounter}`,
            'count': newAudienceCounter,
            'parameters': [
                new ParametersSet([], [], null, "", "", "")
            ]
        });
        handleChange({
            'target': {
                'name': 'audiences',
                'value': newAudiences
            }
        })
    }


    const handleDeleteAudience = (index) => {
        if (currentAbTest.audiences.length > 1) {
            let newAudiences = [...currentAbTest.audiences]
            newAudiences.splice(index, 1)
            handleChange({
                'target': {
                    'name': 'audiences',
                    'value': newAudiences
                }
            })
        }
    }


    const handleParameterDataChange = (params, value, paramIndex, currentAudienceIndex) => {
        let newAbTest = {...currentAbTest};
        let param = params.filter(p => p.name === value)[0];
        if (isVersionNumericParameter(param)) {
            newAbTest.audiences[currentAudienceIndex].parameters[paramIndex] = new VersionNumericParameterSet();
        } else {
            newAbTest.audiences[currentAudienceIndex].parameters[paramIndex] = new ParametersSet();
        }
        let firstRule = param.allowedRules[0];
        let operator = typeof POSSIBLE_OPERATORS.get(firstRule) === 'string' ? POSSIBLE_OPERATORS.get(firstRule) : POSSIBLE_OPERATORS.get(firstRule)[0];
        getCurrentParam(newAbTest, paramIndex, currentAudienceIndex).parameterData = param;
        newAbTest.audiences[currentAudienceIndex].parameters[paramIndex].operator = operator
        setCurrentAbTest(newAbTest);
        _sameParametersCheck();
        _validateManualInput();
    }

    const handleManualInputForOffset = (e, fieldName, paramIndex, currentAudienceIndex) => {
        let newAbTest = {...currentAbTest};
        const currentParam = getCurrentParam(newAbTest, paramIndex, currentAudienceIndex);
        currentParam[fieldName] = e.target.value;
        setCurrentAbTest(newAbTest);
    }

    const handleParameterValueChange = (value, paramIndex, currentAudienceIndex) => {
        let newAbTest = {...currentAbTest};
        let param = getCurrentParam(newAbTest, paramIndex, currentAudienceIndex);
        param.paramValue = value;
        setCurrentAbTest(newAbTest);
        _validateManualInput();
    }

    const handleParameterOperatorChange = (value, paramIndex, currentAudienceIndex) => {
        let newAbTest = {...currentAbTest};
        getCurrentParam(currentAbTest, paramIndex, currentAudienceIndex).operator = value;
        setCurrentAbTest(newAbTest);
    }

    const handleVersionNumericParameterChange = (field, value, paramIndex, audienceIndex) => {
        const newCurrentAbTest = {...currentAbTest};

        const verNumParameter = newCurrentAbTest.audiences[audienceIndex].parameters[paramIndex];


        if(field != "toIncl" && field != 'fromIncl') {
            if (verNumParameter.parameterData.allowedRules.includes('VERSION_RANGE')) {
                verNumParameter[field] = value;
                _validateVersion();
            } else if (verNumParameter.parameterData.allowedRules.includes('NUMBER_RANGE')) {
                if (value !== '' && !(value.toUpperCase() !== value.toLowerCase())) {
                    value = +value
                }
                verNumParameter[field] = value + '';
                _validateNumber();
            }
        } else {
            verNumParameter[field] = value;
        }

        setCurrentAbTest(newCurrentAbTest);
    }


    const _sameParametersCheck = () => {
        let sameParamsErrors = [];
        currentAbTest.audiences.forEach((a, aIndex) => {
            let duplicatesAndUniques =
                getDuplicatesAndUniques(currentAbTest.audiences[aIndex].parameters.map(p => p.parameterData.name));
            duplicatesAndUniques.duplicates.forEach(duplicate => {
                currentAbTest.audiences[aIndex].parameters.forEach((p, pIndex) => {
                    if (p.parameterData.name === duplicate) {
                        sameParamsErrors.push(new AudienceError(aIndex, pIndex, duplicate, "paramNameError"));
                    }
                })
            });
        })
        _handleAudienceErrorRegistration('sameFieldError', sameParamsErrors)
    }

    const _validateVersion = () => {
        let errors = [];
        currentAbTest.audiences.forEach((a, aIndex) => {
                a.parameters.forEach((p, pIndex) => {
                    if (p.parameterData.allowedRules.includes('VERSION_RANGE')) {
                        if (!semverValid(p.paramFromValue)) {
                            errors.push(new AudienceError(aIndex, pIndex, '', 'paramFromValue'))
                        }
                        if (!semverValid(p.paramToValue)) {
                            errors.push(new AudienceError(aIndex, pIndex, '', 'paramToValue'))
                        }
                        if (!semverBothParams(p.paramFromValue, p.paramToValue)) {
                            errors.push(new AudienceError(aIndex, pIndex, '', 'toAndFromValueError'))
                        }
                    }
                })
            }
        )
        _handleAudienceErrorRegistration('versionError', errors)
    }

    const _validateNumber = () => {
        let errors = [];
        currentAbTest.audiences.forEach((a, aIndex) => {
                a.parameters.forEach((p, pIndex) => {
                    if (p.parameterData.allowedRules.includes('NUMBER_RANGE')) {
                        if (!validateSingleNumber(p.paramFromValue)) {
                            errors.push(new AudienceError(aIndex, pIndex, '', 'paramFromValue'))
                        }
                        if (!validateSingleNumber(p.paramToValue)) {
                            errors.push(new AudienceError(aIndex, pIndex, '', 'paramToValue'))
                        }
                        if (!validateLte(p.paramFromValue, p.paramToValue)) {
                            errors.push(new AudienceError(aIndex, pIndex, '', 'toAndFromValueError'))
                        }
                    }
                })
            }
        )
        _handleAudienceErrorRegistration('numberError', errors)
    }

    const _validateManualInput = () => {
        let manualInputErrors = [];
        currentAbTest.audiences.forEach((a, aIndex) => {
            a.parameters.forEach((p, pIndex) => {
                if (isEmpty(p.parameterData.name)) {
                    manualInputErrors.push(new AudienceError(aIndex, pIndex, '', 'paramName'))
                }

                if (!p.parameterData.allowedRules?.includes('VERSION_RANGE') &&
                    !p.parameterData.allowedRules?.includes('PROFILE_OFFSET') &&
                    !p.parameterData.allowedRules?.includes('NUMBER_RANGE')) {

                    // Проверяем что value заполнен
                    if (isEmpty(p.paramValue) || (Array.isArray(p.paramValue) && p.paramValue.length === 0)) {
                        manualInputErrors.push(new AudienceError(aIndex, pIndex, '', 'paramValue'))
                    }

                } else if(p.parameterData.allowedRules?.includes('PROFILE_OFFSET')) {
                    if(isEmpty(p.operator) || isEmpty(p.offset) || isEmpty(p.offerId))
                        manualInputErrors.push(new AudienceError(aIndex, pIndex, '', 'paramValue'))
                }
            })

        })

        _handleAudienceErrorRegistration('paramValueError', manualInputErrors)
    }


    const _handleAudienceErrorRegistration = (errorType, error) => {
        let newStepErrors = [...audienceStepErrors]

        newStepErrors = newStepErrors.filter(i => !i.hasOwnProperty(errorType))
        newStepErrors.push({[errorType]: error});
        setAudienceStepErrors(newStepErrors)
    }

    const _handleSeveralAudienceErrorsRegistration = (errorTypes) => {
        let newStepErrors = [...audienceStepErrors];

        newStepErrors = newStepErrors.filter(stepError => {
            errorTypes.forEach(errorType => {
                return stepError === errorType;
            })
        });
        errorTypes.forEach(errorType => {
            newStepErrors.push({[errorType]: errorType});
        })
        setAudienceStepErrors(newStepErrors)

    }

    const _handleErrorRegistration = (errorName, action = 'delete') => {
        let newStepErrors = [...basicStepErrors]

        if (action === 'delete') {
            newStepErrors = newStepErrors.filter(e => e !== errorName)
        } else {
            if (!newStepErrors.includes(errorName)) {
                newStepErrors.push(errorName)
            }
        }
        setBasicStepErrors(newStepErrors)
    }



    const _findAbsentAudiences = (audiences) => {
        let numbers = audiences.map(a => a.count).sort();
        let absentNumbers = [];
        for (let i = 1; i < numbers[numbers.length - 1]; i++) {
            if (!numbers.includes(i)) {
                absentNumbers.push(i);
            }
        }
        return absentNumbers;
    }

    const getCurrentParam = (campaign, paramIndex, currentAudienceIndex) => {
        return campaign?.audiences[currentAudienceIndex].parameters[paramIndex]
    }

    const prepareAbTestForSave = () => {

        let audiencesForSave = [];
        currentAbTest.audiences.forEach(audience => {
            let audienceForSave = {}
            for (let parameterSet of audience.parameters) {
                audienceForSave = prepareParametersForSave(audienceForSave, parameterSet)
            }
            if(Object.keys(audienceForSave).length > 0)
                audiencesForSave.push(audienceForSave)
        })

        let filter = audiencesForSave[0]
        //filter['platform'] = audienceTitle.platform

        return {
            id: parameters === false ? uuidv4() : parameters.id,
            title: audienceTitle.title,
            description: audienceTitle.description,
            createdAt: "2025-01-01T10:00:00.000Z",
            filter: filter,
        }
    }

    const hasValidationErrors = () => {
        // Проверяем есть ли ошибки в audienceStepErrors
        const hasErrors = audienceStepErrors.some(errorGroup => {
            return Object.keys(errorGroup).some(errorType => {
                return errorGroup[errorType].length > 0;
            });
        });

        // Также проверяем заполненность обязательных полей
        const hasEmptyTitle = isEmpty(audienceTitle.title);

        return hasErrors || hasEmptyTitle;
    }


    const handleSave = async () => {
        setErrorText(null)

        let response
        if(parameters === false) {
            response = await createAudience(prepareAbTestForSave(currentAbTest))
        } else {
            response = await updateAudience(prepareAbTestForSave(currentAbTest))
        }
        console.log('response')
        console.log(response)
        console.log(createAudienceResponse)
        if(!response.hasOwnProperty('error'))
            handleDialogClose()
        else
            setErrorText(response?.error?.data.error)
    }

    return (
        <>
            <CommonModal
                open={open}
                handleDialogClose={handleDialogClose}
                title={"Create Audience"}
            >
                <DialogContent>
                    {errorText!==null&&<Alert sx={{mb:2}} severity={"error"}>
                        {errorText}
                    </Alert>}
                    <AudienceForm
                        currentAbTest={currentAbTest}
                        setCurrentAbTest={setCurrentAbTest}
                        errorFields={audienceStepErrors}
                        handleChange={handleChange}
                        handleManualInput={handleManualInput}
                        handleAddNewParams={handleAddNewParams}
                        handleDeleteParams={handleDeleteParams}
                        handleAddNewAudience={handleAddNewAudience}
                        handleDeleteAudience={handleDeleteAudience}
                        handleParameterDataChange={handleParameterDataChange}
                        handleManualInputForOffset={handleManualInputForOffset}
                        handleParameterValueChange={handleParameterValueChange}
                        handleParameterOperatorChange={handleParameterOperatorChange}
                        handleVersionNumericParameterChange={handleVersionNumericParameterChange}
                        setAudienceTitle={setAudienceTitle}
                        audienceTitle={audienceTitle}
                    />
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        loading={createAudienceResponse.isLoading}
                        variant={'contained'}
                        disabled={hasValidationErrors()}
                        onClick={handleSave}
                    >
                        Save
                    </LoadingButton>
                </DialogActions>
            </CommonModal>
        </>
    )

}